// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════
   Product List Row Card  (listViewLayout)
   ════════════════════════════════════ */
.plrc-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #ffffff;
  /* border: 1px solid #f0f1f3; */
  border-radius: 16px;
  padding: 10px 14px 10px 10px;
  box-sizing: border-box;
  width: 100%;
  transition: box-shadow 0.15s, border-color 0.15s;
}

.plrc-card:hover {
  box-shadow: 0 4px 16px rgba(8, 96, 230, 0.09);
  border-color: #dbeafe;
}

.plrc-card.plrc-card-disabled {
  opacity: 0.6;
  pointer-events: none;
}

.plrc-card.plrc-card-disabled:hover {
  box-shadow: none;
}

.plrc-dark {
  background: var(--dark-blue, #1e2340);
  border-color: rgba(255, 255, 255, 0.08);
}

.plrc-dark .plrc-name { color: #f9fafb; }
.plrc-dark .plrc-price { color: #93c5fd; }

/* ── Thumbnail ── */
.plrc-img-wrap {
  position: relative;
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  overflow: hidden;
  background: #f3f4f6;
}

.plrc-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.plrc-img-loader {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
}

/* ── Content ── */
.plrc-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.plrc-name {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  line-height: 1.3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* ── Meta row ── */
.plrc-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.plrc-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
}

.plrc-price {
  font-size: 13px;
  font-weight: 700;
  color: #111827;
}

.plrc-shortcode {
  font-size: 11px;
  color: #9ca3af;
  font-weight: 500;
}

/* ── Badges ── */
.plrc-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
  white-space: nowrap;
}

.plrc-badge--variants {
  color: #1a56db;
  background: transparent;
  padding: 0;
}

.plrc-badge--oos {
  color: #dc2626;
  background: #fee2e2;
  border: 1px solid #fca5a5;
}

.plrc-badge--unavail {
  color: #92400e;
  background: #fef3c7;
  border: 1px solid #fde68a;
}

/* ── Food type icon ── */
.plrc-food-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  object-fit: contain;
}

/* ── Bundle chips ── */
.plrc-bundles {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 2px;
}

.plrc-bundle-chip {
  font-size: 10px;
  color: #374151;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 1px 6px;
  white-space: nowrap;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.plrc-bundle-chip--more {
  color: #1a56db;
  background: #eff6ff;
  border-color: #bfdbfe;
}

/* ── Includes text ── */
.plrc-includes-text {
  font-size: 11px;
  font-weight: 600;
  color: #6366f1;
  margin: 0;
  line-height: 1;
}

/* ── Add button ── */
.plrc-add-btn {
  flex-shrink: 0;
  width: 45px;
  height: 45px;
  border-radius: 40%;
  border: 1.5px solid #3697FF;
  background: #f9fafb;
  color:#3697FF;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.plrc-add-btn:hover:not(:disabled) {
  background: #eff6ff;
  border-color: #3b82f6;
  color: #1a56db;
}

.plrc-add-btn--disabled,
.plrc-add-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* ── Dark theme ── */
.dark .plrc-card {
  background: #1e293b;
}

.dark .plrc-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  border-color: #334155;
}

.dark .plrc-img-wrap {
  background: #0f172a;
}

.dark .plrc-img-loader {
  background: rgba(30, 41, 59, 0.7);
}

.dark .plrc-name {
  color: #f1f5f9;
}

.dark .plrc-price {
  color: #94a3b8;
}

.dark .plrc-shortcode {
  color: #64748b;
}

.dark .plrc-bundle-chip {
  color: #94a3b8;
  background: #0f172a;
  border-color: #334155;
}

.dark .plrc-bundle-chip--more {
  color: #60a5fa;
  background: #1e3a5f;
  border-color: #334155;
}

.dark .plrc-add-btn {
  background: #0f172a;
  border-color: #3b82f6;
  color: #60a5fa;
}

.dark .plrc-add-btn:hover:not(:disabled) {
  background: #1e3a5f;
  border-color: #60a5fa;
  color: #93c5fd;
}
`, "",{"version":3,"sources":["webpack://./client/src/customComponents/ProductListRowCard/ProductListRowCard.css"],"names":[],"mappings":"AAAA;;yCAEyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA,wBAAwB,cAAc,EAAE;AACxC,yBAAyB,cAAc,EAAE;;AAEzC,oBAAoB;AACpB;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/* ════════════════════════════════════\n   Product List Row Card  (listViewLayout)\n   ════════════════════════════════════ */\n.plrc-card {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: #ffffff;\n  /* border: 1px solid #f0f1f3; */\n  border-radius: 16px;\n  padding: 10px 14px 10px 10px;\n  box-sizing: border-box;\n  width: 100%;\n  transition: box-shadow 0.15s, border-color 0.15s;\n}\n\n.plrc-card:hover {\n  box-shadow: 0 4px 16px rgba(8, 96, 230, 0.09);\n  border-color: #dbeafe;\n}\n\n.plrc-card.plrc-card-disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.plrc-card.plrc-card-disabled:hover {\n  box-shadow: none;\n}\n\n.plrc-dark {\n  background: var(--dark-blue, #1e2340);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.plrc-dark .plrc-name { color: #f9fafb; }\n.plrc-dark .plrc-price { color: #93c5fd; }\n\n/* ── Thumbnail ── */\n.plrc-img-wrap {\n  position: relative;\n  flex-shrink: 0;\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f3f4f6;\n}\n\n.plrc-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.plrc-img-loader {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.7);\n}\n\n/* ── Content ── */\n.plrc-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.plrc-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n  line-height: 1.3;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n/* ── Meta row ── */\n.plrc-meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.plrc-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.plrc-price {\n  font-size: 13px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.plrc-shortcode {\n  font-size: 11px;\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n/* ── Badges ── */\n.plrc-badge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n\n.plrc-badge--variants {\n  color: #1a56db;\n  background: transparent;\n  padding: 0;\n}\n\n.plrc-badge--oos {\n  color: #dc2626;\n  background: #fee2e2;\n  border: 1px solid #fca5a5;\n}\n\n.plrc-badge--unavail {\n  color: #92400e;\n  background: #fef3c7;\n  border: 1px solid #fde68a;\n}\n\n/* ── Food type icon ── */\n.plrc-food-icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  object-fit: contain;\n}\n\n/* ── Bundle chips ── */\n.plrc-bundles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n.plrc-bundle-chip {\n  font-size: 10px;\n  color: #374151;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 1px 6px;\n  white-space: nowrap;\n  max-width: 110px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.plrc-bundle-chip--more {\n  color: #1a56db;\n  background: #eff6ff;\n  border-color: #bfdbfe;\n}\n\n/* ── Includes text ── */\n.plrc-includes-text {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6366f1;\n  margin: 0;\n  line-height: 1;\n}\n\n/* ── Add button ── */\n.plrc-add-btn {\n  flex-shrink: 0;\n  width: 45px;\n  height: 45px;\n  border-radius: 40%;\n  border: 1.5px solid #3697FF;\n  background: #f9fafb;\n  color:#3697FF;\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.plrc-add-btn:hover:not(:disabled) {\n  background: #eff6ff;\n  border-color: #3b82f6;\n  color: #1a56db;\n}\n\n.plrc-add-btn--disabled,\n.plrc-add-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n/* ── Dark theme ── */\n.dark .plrc-card {\n  background: #1e293b;\n}\n\n.dark .plrc-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n  border-color: #334155;\n}\n\n.dark .plrc-img-wrap {\n  background: #0f172a;\n}\n\n.dark .plrc-img-loader {\n  background: rgba(30, 41, 59, 0.7);\n}\n\n.dark .plrc-name {\n  color: #f1f5f9;\n}\n\n.dark .plrc-price {\n  color: #94a3b8;\n}\n\n.dark .plrc-shortcode {\n  color: #64748b;\n}\n\n.dark .plrc-bundle-chip {\n  color: #94a3b8;\n  background: #0f172a;\n  border-color: #334155;\n}\n\n.dark .plrc-bundle-chip--more {\n  color: #60a5fa;\n  background: #1e3a5f;\n  border-color: #334155;\n}\n\n.dark .plrc-add-btn {\n  background: #0f172a;\n  border-color: #3b82f6;\n  color: #60a5fa;\n}\n\n.dark .plrc-add-btn:hover:not(:disabled) {\n  background: #1e3a5f;\n  border-color: #60a5fa;\n  color: #93c5fd;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
